import createSwaggerClient from '../swaggerClient';

const vendorCoreSpecUrl = process.env.REACT_APP_API_VENDOR_CORE_OPEN_API;

const vendorCoreClient = createSwaggerClient(vendorCoreSpecUrl);

export function makeVendorCoreClient() {
  return vendorCoreClient;
}
